export const MODAL_NAME = 'gifts'
export const MODAL_ACTION_SELECT = 'select'
